import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import dots from "../assets/dots.svg";
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { activateUser, deactivateUser, userList } from "../action/user";
import moment from "moment";
import Paginate from "../components/pagination";
import DeleteModal from "../components/DeleteModal";
import ActivateModal from "../components/ActivateModel";
const Account = () => {
    const navigate = useNavigate();
    const location = useLocation();
  const params = useParams();
    const [activeTab, setActiveTab] = useState("user");
     const [users, setUsers] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [showActivateModal, setShowActivateModal] = useState(false);
      const [id, setId] = useState("");
      const [deleteLoader, setDeleteLoader] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
      });
      const fetchUsers = async () => {
        try {
          const res = await userList(pagination.page,pagination.limit);
            if (res?.status) {
                setPagination((prev) => ({
                    ...prev,
                    total: Math.ceil(res.data.total / prev.limit) || 0,
                  }));
            setUsers(res.data.list);
          }
        } catch (error) {
          console.log("Error");
        }
      };
    
      const handleDelete = async () => {
        setDeleteLoader(true);
        try {
          const res = await deactivateUser(id);
          if (res.status) {
            fetchUsers();
          }
        } catch (e) {
          console.log("Falied to delete", e);
        }
        setDeleteLoader(false);
        setShowDeleteModal(false);
        setId("");
      };
  
  const handleActivate = async () => {
      setDeleteLoader(true);
      try {
        const res = await activateUser(id);
        if (res.status) {
          fetchUsers();
        }
      } catch (e) {
        console.log("Falied to activate user account", e);
      }
      setDeleteLoader(false);
      setShowActivateModal(false);
      setId("");
    };
    const handlePageChange = (page) => {
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", page);
        newParams.set("limit", pagination.limit);
    
        navigate(`?${newParams.toString()}`, { replace: true });
    
        setPagination((prev) => ({ ...prev, page: page }));
      };
    
      const handlePageSizeChange = (limit) => {
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", 1);
        newParams.set("limit", limit);
    
        navigate(`?${newParams.toString()}`, { replace: true });
    
        setPagination((prev) => ({ ...prev, limit: limit, page: 1 }));
      };
    
      useEffect(() => {
        fetchUsers();
      }, [params]);
    return (
      <>
        <PageHeader pageTitle="Account" is_deploy_enable={false}>
          <Link to="/account/create-new-account" className="btn-black">
            Create New User
          </Link>
        </PageHeader>

        <div className="page-container">
          <div className="role-header mb-4">
            <div className="role-tabs">
              <Link to="/account" className="role-tab active">
                Users
              </Link>
              <Link to="/role" className="role-tab">
                Roles
              </Link>
            </div>
          </div>
          <div className="theme-card p-4">
            <div className="d-flex align-items-center mb-3">
              <div className="card-title pb-3">Users</div>
              {/* <div className="sel-box ms-auto">
                <select name="selmenu" id="selmenu" className="theme-select">
                  <option value="">Filter</option>
                  <option value="">Filter Options</option>
                </select>
              </div> */}
            </div>
            <table className="pages-table">
              <thead>
                <tr>
                  <th>User name</th>
                  <th>Email</th>
                  <th>role</th>
                  <th>Date created</th>
                  <th>Access</th>
                  <th className="text-end" width="10%">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {users &&
                  users.map((user, i) => {
                    return (
                      <tr key={i}>
                        <td>{user.name}</td>
                        <td>{user?.email}</td>
                        <td>{user?.role || "Admin"}</td>
                        <td>{moment(user?.createdAt).format("DD/MM/YYYY")}</td>
                        <td>
                          <span className={`status ${user.is_active ? "success" : "danger"}`}>
                            {user.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="text-end" width="10%">
                          <Dropdown align="end">
                            <Dropdown.Toggle variant="button">
                              <button className="dotbtn">
                                <img src={dots} alt="" />
                              </button>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="sm">
                              <Dropdown.Item
                                as={Link}
                                to={`/account/edit-account/${user._id}`}
                              >
                                Edit
                              </Dropdown.Item>
                              {!user.is_active ? (
                              <Dropdown.Item
                                as={Link}
                                to="#"
                                className="text-success"
                                onClick={() => {
                                  setId(user._id);
                                  setShowActivateModal(true);
                                }}
                              >
                                Activate
                              </Dropdown.Item>
                            ) : (
                              <Dropdown.Item
                                as={Link}
                                to="#"
                                className="text-danger"
                                onClick={() => {
                                  setId(user._id);
                                  setShowDeleteModal(true);
                                }}
                              >
                                Deactivate
                              </Dropdown.Item>
                            )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="px-3 pb-3">
              {Boolean(pagination?.total) && (
                <Paginate
                  currentPage={pagination?.page}
                  totalPages={pagination?.total}
                  onPageChange={handlePageChange}
                  pageSize={pagination.limit}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </div>
          </div>
        </div>
         <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onDelete={handleDelete}
                deleting={deleteLoader}
              />
              <ActivateModal
                title="User"
                show={showActivateModal}
                onClose={() => setShowActivateModal(false)}
                onDelete={handleActivate}
                deleting={deleteLoader}
              />
      </>
    );
}

export default Account